import React from 'react';
import { Translation } from 'react-i18next';

import { AlertCircle }from 'tabler-icons-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';

import './EarnDisclaimer.css';

const EarnDisclaimer = () => (
  <Translation>
    {(t) => (
      <AnalyticsSection
      className="earn-disclaimer__component"
      >
        <p className="alert-text">
          <span><AlertCircle /></span>
          <span>{t("Congratulations! You were accepted to our BETA Earn program. It is still in the testing mode. It might take couple of weeks before it will be fully operational. Thanks for your patience :)")}</span>
        </p>
      </AnalyticsSection>
    )}
  </Translation>
);

export default EarnDisclaimer;
